module.exports = __webpack_public_path__ + "static/media/но.a10a720e.mp3";